import type { TenantConfig } from '@/types/TenantConfig'

export const smv: TenantConfig = {
  logo: 'assets/smv/static/logo.png',
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css2?family=Oswald:wght@600;700&family=Roboto:ital,wght@0,400;0,700;1,400;1,700&display=swap',
    },
  },
  i18nOverrides: {
    en: {
      applyPromoCodes: {
        applyPromoCodeLabel: 'Add Discount Code',
      },
      payButton: {
        desktop: {
          proceedButtonLabel: 'Continue to Payment',
        },
      },
    },
  },
}
